import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=4d0ce27e&scoped=true&"
import script from "./SystemMessage.vue?vue&type=script&lang=ts&"
export * from "./SystemMessage.vue?vue&type=script&lang=ts&"
import style0 from "./SystemMessage.vue?vue&type=style&index=0&id=4d0ce27e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0ce27e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardText,VSheet})
